module.exports = __webpack_public_path__ + "img/s.85efe77f.webp";